import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ location }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const closeOnEscape = (event) => { if (event.key === 'Escape') setMobileMenuOpen(false); };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, []);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${isHome ? 'header-dark' : ''}`}>
      <div className="container header-container">
        <Link to="/" className="logo">
          <img
            src="/bai-logo.png"
            alt="BAi Systems"
            className="logo-mark"
          />
        </Link>

        <button
          className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
          aria-controls="main-navigation"
        >
          <span></span>
          <span></span>
        </button>

        <nav id="main-navigation" aria-label="Main navigation" className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/builders" className={isActive('/builders')}>Builders</Link>
          <Link to="/architects" className={isActive('/architects')}>Architects</Link>
          <Link to="/homeowners" className={isActive('/homeowners')}>Homeowners</Link>
          <Link to="/partners" className={isActive('/partners')}>Partners</Link>
          <Link to="/wellwired" className={isActive('/wellwired')}>Wellwired</Link>
          <Link to="/consulting" className={isActive('/consulting')}>Consulting</Link>
          <Link to="/about" className={isActive('/about')}>About</Link>
          <a href="https://portal.bai-systems.com" target="_blank" rel="noopener noreferrer" className="nav-portal">myBAi</a>
          <Link to="/contact" className={`nav-cta ${isActive('/contact')}`}>Contact</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
